import { useI18N } from "@sundae/react-hooks";
import { ExternalLink, FadeInBasic, Notice, Text } from "@sundae/ui-toolkit";
import isEmpty from "lodash/isEmpty";
import { FC } from "react";
import { TasteTest } from "../../../gql/generated/taste-test.sdk";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import TasteTestEmptyChartView from "../TasteTestEmptyChartView";
import TasteTestVestingScheduleChart from "../TasteTestVestingScheduleChart";

const TasteTestVestingScheduleNotice: FC<{ tasteTest: TasteTest }> = ({ tasteTest }) => {
  const { t } = useI18N("glossary");

  if (!tasteTest?.vestingNotice) {
    return null;
  }

  return (
    <Notice title={t("info")} type="info" size="xs">
      <div>
        <Text tag="p" size="xs" variant="info">
          {tasteTest.vestingNotice.notice}
        </Text>
        <ExternalLink
          href={tasteTest.vestingNotice.url}
          arrow="top-right"
          size="xs"
          variant="primary"
          className="inline-block"
        >
          {tasteTest.vestingNotice.url}
        </ExternalLink>
      </div>
    </Notice>
  );
};

const TasteTestVestingSchedule: FC = () => {
  const { t } = useI18N("taste-test");
  const {
    state: { tasteTest },
  } = useTasteTestContext();

  /* -------------------------------------------------------------------------------------------------
   * Notice for no available Vesting Schedule Information
   * -----------------------------------------------------------------------------------------------*/
  if (!tasteTest?.vestingNotice && isEmpty(tasteTest?.vestingSchedule)) {
    return (
      <TasteTestEmptyChartView
        title={t("detail.projectDetails.vestingSchedule.noData", { context: "title" })}
        description={t("detail.projectDetails.vestingSchedule.noData")}
      />
    );
  }

  if (tasteTest?.vestingNotice && isEmpty(tasteTest?.vestingSchedule)) {
    return <TasteTestVestingScheduleNotice tasteTest={tasteTest} />;
  }

  return (
    <FadeInBasic className="relative flex flex-col gap-4 rounded-lg pt-4 lg:pt-0 xl:max-h-[48rem]">
      <div className="relative mx-auto grid w-full max-w-3xl gap-4 space-y-4 lg:col-span-2 lg:mx-0 lg:h-fit">
        {tasteTest?.vestingNotice && <TasteTestVestingScheduleNotice tasteTest={tasteTest} />}
        <TasteTestVestingScheduleChart />
      </div>
    </FadeInBasic>
  );
};

export default TasteTestVestingSchedule;
